import { Theme, createStyles, makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme: Theme) =>
  createStyles({
    chart: {
      maxHeight: '240px'
    }
  })
)
